import * as React from "react";
import moment from "moment";
import { getVerificationResult } from "../../services/verificationService";
import { WarningIcon } from "../Icons/WarningIcon";

export const FacesheetLTCIPR = ({ risks, caseClues }) => {
    let comprehensiveCaseClues = [...risks[0].score.reasons, ...caseClues.data];
    return (
        <div className="marketplace-cards__long-term-care-card__program-risks">
            <div className="risk-items">
                <ul>
                    {comprehensiveCaseClues.map((element, index) => {
                        return (
                            <li key={`risks_${index}`}>
                                <p>
                                    <WarningIcon />
                                    {element}
                                </p>
                            </li>
                        );
                    })}
                    {comprehensiveCaseClues.length === 0 && (
                        <div>
                            <p>No Risks Identified</p>
                        </div>
                    )}
                </ul>
            </div>
        </div>
    );
};
